<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/epidemic/epideAreaList' }">地区配置</el-breadcrumb-item>
            <el-breadcrumb-item>疫情数据 - 国家</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="headContainer">
          <el-backtop target=".headContainer">
            <i class="el-icon-caret-top"></i>
          </el-backtop>
          <el-form ref="formData" :model="formData" label-width="120px">
            <el-form-item label="国家名称：">{{countryName}}</el-form-item>
            <el-form-item label="数据更新时间：">
              <el-date-picker
                v-model="formData.update_time"
                type="datetime"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="整体：">
              <el-row>
                <el-col :span="6">
                  <span>新增确诊</span>
                  <el-input
                    style="width: 150px; margin-left: 15px"
                    v-model="formData.new_confirmed"
                  ></el-input>
                </el-col>
              </el-row>
              
              <el-row>
                <el-col :span="6">
                  <span>现存确诊</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.remain_confirmed"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <span>较昨日</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.remain_confirmed_compare"
                  ></el-input>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <span>累计确诊</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.total_confirmed"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <span>较昨日</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.total_confirmed_compare"
                  ></el-input>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <span>累计治愈</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.total_recoveries"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <span>较昨日</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.total_recoveries_compare"
                  ></el-input>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <span>累计死亡</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.total_death"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <span>较昨日</span>
                  <el-input
                    style="width: 150px; margin-top: 20px;margin-left: 15px"
                    v-model="formData.total_death_compare"
                  ></el-input>
                </el-col>
              </el-row>

            </el-form-item>

            <el-form-item class="area_lafite" label="地区：">
              <div v-for="(item,index) in area_data" :key="index">
                <el-input v-model="area_data[index].area" placeholder="请输入地区" style="width:150px; margin-bottom: 20px"></el-input>
                <el-input v-model="area_data[index].new_confirmed" placeholder="新增确诊" style="width:100px; margin-left: 10px"></el-input>
                <el-input v-model="area_data[index].total_confirmed" placeholder="累计确诊" style="width:100px; margin-left: 10px"></el-input>
                <el-input v-model="area_data[index].total_recoveries" placeholder="累计治愈" style="width:100px; margin-left: 10px"></el-input>
                <el-input v-model="area_data[index].total_death" placeholder="累计死亡" style="width:100px; margin-left: 10px"></el-input>
                <el-input v-model="area_data[index].hc_key" placeholder="请输入hc-key" style="width:150px; margin-left: 10px"></el-input>
              </div>
              <el-button type="primary" @click="areaAdd">添加</el-button>
              <div>
                <el-button style="margin-top: 30px;margin-bottom: 30px" type="primary" @click="onSubmit">提交</el-button>
                <el-button @click="goBack">取消</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";
import { formatTimeToStr } from './component/fomat_time';
import TipUtil from "@/utils/utils/TipUtil";
export default {
  components: { },
  data() {
    return {
      ids: this.$route.query.id,
      countryName: "",
      area_data: [
        {area: "", new_confirmed: "",total_confirmed: "", total_recoveries: "", total_death: "", hc_key: ""}
      ],
      formData: {
        //参数
       
      }
    };
  },
  created() {
    this.epidemicDatas()
  },
  methods: {
    async epidemicDatas() {
      let res = await api.epidemicDatas({
        id: this.ids
      })
      this.countryName = res.info.area_name
      this.formData = res.info
      this.area_data = this.formData.area_data_data || [{area: "", new_confirmed:"", total_confirmed: "", total_recoveries: "", total_death: "", hc_key: ""}]
    },
    async onSubmit() {
      for(let i = 0; i < this.area_data.length; i++) {
        if(this.area_data[i].total_confirmed == "" || this.area_data[i].total_confirmed == "0") {
          delete this.area_data[i].total_confirmed
        }
      }
      this.formData.area_data = JSON.stringify(this.area_data)
      this.formData.id = this.ids
      this.formData.update_time = formatTimeToStr(this.formData.update_time)
      delete this.formData.area_data_data
      let res = await api.epidemicDatasEdit(this.formData)
      if(res.error_code == 0) {
        TipUtil.message("信息提交成功！！", "success");
        this.$router.push("/epidemic/epideAreaList");
      }
    },
    areaAdd() {
      this.area_data.push({area: "", total_confirmed: "", total_recoveries: "", total_death: "",hc_key: ""})
    },
    // 取消跳转原页面
    goBack() {
      this.$router.push("/epidemic/epideAreaList");
    }
  }
};
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
  color: #8b8b8b;
}
.headContainer {
  height: 100vh;
  // overflow-x: hidden;
}
.area_lafite {
  background: white;
}
</style>
